/** Display name used consistently in Open Graph / Twitter meta. */
export const SITE_NAME = "Sugar Cribs";

/** Default share image path (served from site root, same as Organization logo). */
export const DEFAULT_OG_IMAGE_PATH = "/logo512.png";
